// Fix price display issues
document.addEventListener('DOMContentLoaded', function() {
  function fixPrices() {
    // Fix HTML rendering issues - with improved Safari compatibility
    const priceElements = document.querySelectorAll('.price, [class*="price"], .variant-item__details, .variant-item__price, .totals__total-value, .totals__subtotal-value, p.price, span.money');
    
    priceElements.forEach(function(element) {
      // Check for broken HTML and fix it
      if (element.innerHTML.includes('&lt;span class=money&gt;')) {
        // First, handle the case with "/ea" suffix
        let fixedHtml = element.innerHTML;
        
        // First pattern - remove "/ea" completely
        fixedHtml = fixedHtml.replace(/&lt;span class=money&gt;([^&]*)&lt;\/span&gt;\/ea/g, '<span class="money">$1</span>');
        
        // Second pattern - handle cases without "/ea"
        fixedHtml = fixedHtml.replace(/&lt;span class=money&gt;([^&]*)&lt;\/span&gt;/g, '<span class="money">$1</span>');
        
        // Apply the fixed HTML
        element.innerHTML = fixedHtml;
      }
      
      // Additional cleanup for any "/ea" that might still be visible
      if (element.innerHTML.includes('/ea')) {
        element.innerHTML = element.innerHTML.replace(/\/ea/g, '');
      }
      
      // Clean up redundant currency display
      if (element.textContent.includes('Dhs') && element.textContent.includes('AED')) {
        const cleanHtml = element.innerHTML.replace(/Dhs/g, '');
        element.innerHTML = cleanHtml;
      }
    });
    
    // TARGETED FIX: remove the "price" class from elements that should have strikethrough
    document.querySelectorAll('s.variant-item__old-price.price').forEach(function(el) {
      // Remove the problematic "price" class
      el.classList.remove('price');
      // Force the strikethrough just to be sure
      el.style.textDecoration = 'line-through';
    });
  }
  
  // Run immediately
  fixPrices();
  
  // Run on window load (important for Safari)
  window.addEventListener('load', fixPrices);
  
  // Run periodically to catch dynamically loaded content
  setInterval(fixPrices, 500);
  
  // Special Safari detector
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    // Run more frequently on Safari
    setInterval(fixPrices, 200);
  }
});